module.exports = __webpack_public_path__ + "static/media/Two.6e0190f2.png";